import React from 'react'
import { Row } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import Card from './card'
import './style.scss'

const Index = () => {

    const paymentMethods = useSelector(state => state.company.paymentMethods?.cards)

    return(
        <div className="all-payment-methods-container">
            <div className="inner-all-payment-methods-container">
                {paymentMethods && paymentMethods.length > 0 &&
                    <Row className="payment-methods-row">
                        {paymentMethods.map((method) => {
                            return(
                                <Card details={method}/>
                            )
                        })}
                    </Row>
                }
            </div>
        </div>
    )
}

export default Index